import { graphql } from "msw";
import { ONEPASS_EXPERIMENT_ID } from "@analytics/consts";
import { Experiment } from "@analytics/generated/graphql";

const mockOnePassExperiment: Experiment = {
  experiment: ONEPASS_EXPERIMENT_ID,
  bucket: 0,
  variation: "soft launch",
  active: true,
  id: "192",
  name: "OnePass stage2 soft launch",
  __typename: "Experiment",
};

export const experimentsHandler = [
  graphql.query("Experiments", (_req, res, ctx) => {
    return res(
      ctx.data({
        experiments: {
          experiments: [mockOnePassExperiment],
          __typename: "ExperimentsPayload",
        },
      })
    );
  }),
];
